export const CONNECT_ENDPOINTS = {
  postConnectTelegramPhone: "/telegram/connections/",
  postConnectWhatsAppPhone: "/whatsapp/connect-whatsapp/",
  postConnectWhatsAppCheck: "/whatsapp/connections-check/",
  deleteConnectWhatsAppDisconnect: "/whatsapp/disconnect-whatsapp/",
};
